export default __webpack_public_path__ + "../staticImages/pdp-bg-default-d.jpg";